import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { FC } from "react";
import { theme } from "../../../../theme";
import { useTranslation } from "react-i18next";

interface ForgotPasswordModalProps {
  open: boolean;
  handleClose: () => void;
}

export const ForgotPasswordModal: FC<ForgotPasswordModalProps> = ({
  open,
  handleClose,
}) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth={isMobile}
    >
      <DialogTitle id="alert-dialog-title" sx={{ textAlign: "center" }}>
        {t("auth.forgotPasswordModal.header")}
      </DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          width: { xs: "sm", sm: "350px", md: "350px" },
        }}
      >
        <Typography align="center">
          {t("auth.forgotPasswordModal.content")}
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{ marginBottom: "10px", display: "flex", justifyContent: "center" }}
      >
        <Button onClick={handleClose} variant="contained" color="primary">
          {t("auth.okay")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
